import React, { Component } from "react";
import { connect } from "react-redux";
import { ADR_EDIT } from "../../_constants/actionConstants";
import AdrGeneralCommentRowV3 from "./AdrGeneralCommentRowV3";

class AdrGeneralCommentsV3 extends Component {
  componentDidMount() {
    this.addBlankIfEmpty();
  }

  componentDidUpdate(prevProps, prevState) {
    this.addBlankIfEmpty();
  }

  addBlankIfEmpty = () => {
    const { dispatch, tabId, generalComments } = this.props;
    if (
      !generalComments ||
      !Array.isArray(generalComments) ||
      generalComments.length === 0
    )
      dispatch({ type: ADR_EDIT.GENERAL_COMMENTS.ADD, tabId });
  };

  handleClick_addGcr = (e) => {
    e.preventDefault();
    const { dispatch, tabId, markAdrDirty } = this.props;
    dispatch({ type: ADR_EDIT.GENERAL_COMMENTS.ADD, tabId });
    markAdrDirty();
  };

  render() {
    const { tabId, projectId, generalComments, fileUploadModal, markAdrDirty, status } =
      this.props;
    return (
      <React.Fragment>
        <div className="card m-2">
          <div className="card-body">
            <h3>General Comments</h3>
            <hr className="mb-2 mt-2" />
            {generalComments &&
              generalComments.map((comment, index) => (
                <AdrGeneralCommentRowV3
                  key={`gcRowKey_${comment.clientId}`}
                  tabId={tabId}
                  projectId={projectId}
                  comment={comment}
                  fileUploadModal={fileUploadModal}
                  markAdrDirty={markAdrDirty}
                  status={status}
                />
              ))}
            <div className="form-row">
              <div className="col-2">
                <button
                  className="btn btn-secondary"
                  id="addGcrButton"
                  onClick={this.handleClick_addGcr}
                  disabled={status.isReadOnly}
                >
                  Add Comment
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  generalComments: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].generalComments || []
    : null,
});

export default connect(mapStateToProps)(AdrGeneralCommentsV3);
